var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShipmentLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.77,
    y: 3,
    width: 2.769,
    height: 8,
    rx: 0.426,
    fill: "#484848"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.461,
    y: 3,
    width: 1.846,
    height: 8,
    rx: 0.426,
    fill: "#979797"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 1.846,
    height: 8,
    rx: 0.426,
    fill: "#979797"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 3,
    width: 2.769,
    height: 8,
    rx: 0.426,
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShipmentLabel);
export default __webpack_public_path__ + "static/media/ic_shipment_label.395a1675eebb3d5243623e832dfc6376.svg";
export { ForwardRef as ReactComponent };